var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.98999 14C3.98999 13.2599 4.58993 12.66 5.32999 12.66C6.07005 12.66 6.66999 13.2599 6.66999 14C6.66999 14.7401 6.07005 15.34 5.32999 15.34C4.58993 15.34 3.98999 14.7401 3.98999 14Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.33 14C11.33 13.2599 11.9299 12.66 12.67 12.66C13.4101 12.66 14.01 13.2599 14.01 14C14.01 14.7401 13.4101 15.34 12.67 15.34C11.9299 15.34 11.33 14.7401 11.33 14Z",
    fill: "#6B7280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6766 0.669983L2.73548 0.672596C3.02598 0.698056 3.26953 0.910386 3.33155 1.19996L3.93547 4.01998L14.7634 4.01998C14.9666 4.01999 15.159 4.11208 15.2862 4.27058C15.4134 4.42906 15.4617 4.63688 15.4177 4.83523L14.312 9.81314L14.3113 9.81247C14.2129 10.259 13.966 10.659 13.6099 10.9457C13.2981 11.1968 12.9194 11.3477 12.5231 11.3821L12.3523 11.39L5.7989 11.39C5.33666 11.3969 4.88602 11.2443 4.52302 10.9575C4.20199 10.7038 3.96718 10.3593 3.84779 9.97079L3.80395 9.80202L2.74268 4.84897C2.73927 4.83495 2.73604 4.82081 2.73352 4.80645L2.13484 2.00998L1.3366 2.00998C0.966568 2.00998 0.666595 1.71001 0.666595 1.33998C0.666595 0.969949 0.966568 0.669983 1.3366 0.669983L2.6766 0.669983ZM5.11385 9.52062L5.12825 9.5769C5.16802 9.70655 5.24689 9.82145 5.35398 9.90601C5.47622 10.0026 5.62814 10.0534 5.78385 10.05L12.3504 10.05C12.5027 10.0497 12.6504 9.99759 12.7691 9.90212C12.8879 9.80651 12.9706 9.67285 13.0034 9.52391L13.004 9.52263L13.9279 5.35998L4.2227 5.35998L5.11385 9.52062Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.f8087dd97ca73b01db2d512cc569cc29.svg";
export { ForwardRef as ReactComponent };